import { render } from "./PVDataTableStundenaufzeichnung.vue?vue&type=template&id=a2bd68bc"
import script from "./PVDataTableStundenaufzeichnung.vue?vue&type=script&lang=js"
export * from "./PVDataTableStundenaufzeichnung.vue?vue&type=script&lang=js"

import "./PVDataTableStundenaufzeichnung.vue?vue&type=style&index=0&id=a2bd68bc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__